/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JobAdvertOccupation } from './JobAdvertOccupation';
import {
    JobAdvertOccupationFromJSON,
    JobAdvertOccupationFromJSONTyped,
    JobAdvertOccupationToJSON,
} from './JobAdvertOccupation';
import type { JobResultCompany } from './JobResultCompany';
import {
    JobResultCompanyFromJSON,
    JobResultCompanyFromJSONTyped,
    JobResultCompanyToJSON,
} from './JobResultCompany';
import type { JobResultPerson } from './JobResultPerson';
import {
    JobResultPersonFromJSON,
    JobResultPersonFromJSONTyped,
    JobResultPersonToJSON,
} from './JobResultPerson';

/**
 * 
 * @export
 * @interface JobResultItem
 */
export interface JobResultItem {
    /**
     * 
     * @type {number}
     * @memberof JobResultItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof JobResultItem
     */
    jobtitle?: string;
    /**
     * 
     * @type {string}
     * @memberof JobResultItem
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof JobResultItem
     */
    url?: string;
    /**
     * 
     * @type {JobResultCompany}
     * @memberof JobResultItem
     */
    company?: JobResultCompany;
    /**
     * 
     * @type {JobResultPerson}
     * @memberof JobResultItem
     */
    contact?: JobResultPerson;
    /**
     * 
     * @type {string}
     * @memberof JobResultItem
     */
    formattedLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof JobResultItem
     */
    source?: string;
    /**
     * 
     * @type {Date}
     * @memberof JobResultItem
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof JobResultItem
     */
    formattedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof JobResultItem
     */
    level?: string;
    /**
     * 
     * @type {string}
     * @memberof JobResultItem
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof JobResultItem
     */
    jobId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JobResultItem
     */
    primaryAd?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobResultItem
     */
    companySite?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobResultItem
     */
    listOfLinks?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof JobResultItem
     */
    isSavedAdvert?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof JobResultItem
     */
    createdDateSavedAdvert?: Date;
    /**
     * 
     * @type {Array<JobAdvertOccupation>}
     * @memberof JobResultItem
     */
    occupations?: Array<JobAdvertOccupation>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof JobResultItem
     */
    classifications?: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the JobResultItem interface.
 */
export function instanceOfJobResultItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JobResultItemFromJSON(json: any): JobResultItem {
    return JobResultItemFromJSONTyped(json, false);
}

export function JobResultItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobResultItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'jobtitle': !exists(json, 'Jobtitle') ? undefined : json['Jobtitle'],
        'text': !exists(json, 'Text') ? undefined : json['Text'],
        'url': !exists(json, 'Url') ? undefined : json['Url'],
        'company': !exists(json, 'Company') ? undefined : JobResultCompanyFromJSON(json['Company']),
        'contact': !exists(json, 'Contact') ? undefined : JobResultPersonFromJSON(json['Contact']),
        'formattedLocation': !exists(json, 'FormattedLocation') ? undefined : json['FormattedLocation'],
        'source': !exists(json, 'Source') ? undefined : json['Source'],
        'date': !exists(json, 'Date') ? undefined : (new Date(json['Date'])),
        'formattedDate': !exists(json, 'FormattedDate') ? undefined : json['FormattedDate'],
        'level': !exists(json, 'Level') ? undefined : json['Level'],
        'location': !exists(json, 'Location') ? undefined : json['Location'],
        'jobId': !exists(json, 'JobId') ? undefined : json['JobId'],
        'primaryAd': !exists(json, 'PrimaryAd') ? undefined : json['PrimaryAd'],
        'companySite': !exists(json, 'CompanySite') ? undefined : json['CompanySite'],
        'listOfLinks': !exists(json, 'ListOfLinks') ? undefined : json['ListOfLinks'],
        'isSavedAdvert': !exists(json, 'IsSavedAdvert') ? undefined : json['IsSavedAdvert'],
        'createdDateSavedAdvert': !exists(json, 'CreatedDateSavedAdvert') ? undefined : (new Date(json['CreatedDateSavedAdvert'])),
        'occupations': !exists(json, 'Occupations') ? undefined : ((json['Occupations'] as Array<any>).map(JobAdvertOccupationFromJSON)),
        'classifications': !exists(json, 'Classifications') ? undefined : json['Classifications'],
    };
}

export function JobResultItemToJSON(value?: JobResultItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Jobtitle': value.jobtitle,
        'Text': value.text,
        'Url': value.url,
        'Company': JobResultCompanyToJSON(value.company),
        'Contact': JobResultPersonToJSON(value.contact),
        'FormattedLocation': value.formattedLocation,
        'Source': value.source,
        'Date': value.date === undefined ? undefined : (value.date.toISOString()),
        'FormattedDate': value.formattedDate,
        'Level': value.level,
        'Location': value.location,
        'JobId': value.jobId,
        'PrimaryAd': value.primaryAd,
        'CompanySite': value.companySite,
        'ListOfLinks': value.listOfLinks,
        'IsSavedAdvert': value.isSavedAdvert,
        'CreatedDateSavedAdvert': value.createdDateSavedAdvert === undefined ? undefined : (value.createdDateSavedAdvert.toISOString()),
        'Occupations': value.occupations === undefined ? undefined : ((value.occupations as Array<any>).map(JobAdvertOccupationToJSON)),
        'Classifications': value.classifications,
    };
}

